<template>
  <v-app id="facilities-information-tool">
    <v-app-bar app color="primary" dark flat clipped-left class="d-flex align-center fill-width">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-app-bar-title class="pt-0" style="width: 100% !important">
        FACILITIES INFORMATION TOOL
      </v-app-bar-title>

      <v-spacer></v-spacer>

      <user-profile class="pr-5"/>

      <global-search class="mt-5"></global-search>

      <!--      <img
                class="pl-2 pr-3 hidden-sm-and-down"
                src="./assets/masthead-helmet-white.svg"
                height="33"
                alt="MSU Masthead"
            />
            <img
                class="pl-2 pr-3 hidden-md-and-up"
                src="./assets/Spartan-helmet-White-50-pxls.gif"
                height="33"
                alt="MSU Masthead"
            />-->
    </v-app-bar>

    <v-navigation-drawer
        app
        bottom
        clipped
        class="pa-3"
        v-model="drawer"
        color="menu"
        width="350"
    >
      <v-subheader class="pa-0 pl-1">
        <strong>MAIN MENU</strong>
        <v-spacer></v-spacer>
        <v-btn @click.stop="drawer = false" x-small plain class="pr-0">
          <v-icon>{{ drawerCloseIcon }}</v-icon>
        </v-btn>
      </v-subheader>

      <v-list dense nav>
        <template v-for="route in primaryRoutes">
          <template v-if="route.childRoutes.length > 0">
            <div :key="route.title">
              <v-divider/>

              <v-list-group
                  :value="false"
                  no-action
                  class="pl-0 app-menu-group__header"
                  active-class="app-menu-group__items"
                  multiple
                  :title="route.description || route.title"
              >
                <template v-slot:activator>
                  <v-list-item-icon class="ml-n2">
                    <v-icon small>{{ route.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="v-list-group-header"
                  >{{ route.title }}
                  </v-list-item-title>
                </template>

                <div class="app-menu-group__items">
                  <template v-for="route in route.childRoutes">
                    <v-list-item
                        class="pt-0 pb-0 pl-15"
                        :key="route.title"
                        :to="route.to || null"
                        :href="route.href || null"
                        :title="route.description || route.title"
                    >
                      <v-list-item-icon class="pl-4">
                        <v-icon small>{{ route.icon || "mdi-home" }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ route.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </div>
              </v-list-group>
            </div>
          </template>

          <template v-else>
            <v-divider :key="route.title + '-divider'"/>
            <v-list-item
                class="pb-0 pt-0 pl-0 v-list-item--primary-route"
                :key="route.title"
                :to="route.to"
                :href="route.href || null"
                :title="route.description || route.title"
            >
              <v-list-item-icon>
                <v-icon small>{{ route.icon || "mdi-home" }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ route.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>

        <v-divider/>

        <v-list-item
            class="pl-2"
            href="https://fissupport.ipf.msu.edu/kb/a197/fit-2023-new-look.aspx"
            title="Learn about what is new in this application!"
            @click="trackFaqLinkClick"
        >
          <v-list-item-icon>
            <v-icon small>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>WHAT'S NEW?</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-spacer></v-spacer>
      <template v-slot:append>
        <v-alert
            v-if="showOldVersionNotice"
            dismissible
            text
            color="grey"
            border="left"
            colored-border
            dense
            class="mb-5"
        >The old version of this application is available
          <a href="https://apps.gis.msu.edu/facilities-information-tool/v3/"
          >here</a
          >
          until 10/01/2023.
        </v-alert>

        <img
            class="pl-2 pr-3 hidden-md-and-up"
            src="./assets/Spartan-helmet-White-50-pxls.gif"
            height="33"
            alt="MSU Masthead"
        />

        <img
            class="pl-2 pr-3 hidden-sm-and-down"
            src="./assets/masthead-helmet-black.svg"
            height="33"
            alt="MSU Masthead"
        />
      </template>
    </v-navigation-drawer>

    <v-main app>
      <transition name="fade" appear>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </v-main>

    <v-footer app inset class="hidden-md-and-down">
      <app-footer></app-footer>
    </v-footer>
  </v-app>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import GlobalSearch from "@/components/GlobalSearch.vue";
import UserProfile from "@/modules/profile/components/UserProfile.vue";

export default {
  name: "App",
  components: {UserProfile, GlobalSearch, AppFooter},
  data: () => ({
    drawer: true,
    mapLinks: [
      {
        title: 'MAPS (external apps)',
        icon: 'mdi-map-marker-radius-outline',
        childRoutes: [
          {
            title: 'ASSETS MAP (external)',
            description: 'This app is heavily focused on building assets maintained by IPF and allows you to look at assets, floor-by-floor, search for assets and execute queries for groups of assets.',
            icon: 'mdi-map-marker-radius-outline',
            href: 'https://apps.gis.msu.edu/facilities-information-tool/maps/assets'
          },
          {
            title: 'CAMPUS MAP (external)',
            description: 'This map contains generally available facility information for anyone and does not require a login or special access.',
            icon: 'mdi-map-marker-radius-outline',
            href: 'https://apps.gis.msu.edu/facilities-information-tool/maps/campus'
          },
          {
            title: 'CONSTRUCTION DETOURS (external)',
            description: 'This application allows you to look at current and future construction impacts and get directions around campus.',
            icon: 'mdi-map-marker-radius-outline',
            href: 'https://apps.gis.msu.edu/construction/closures-and-detours/'
          },
          {
            title: 'BENCHMARKS MAP (external)',
            description: 'This application is focused on MSU\'s network of benchmarks and is intended for staff and business partners conducting survey operations and related activities.',
            icon: 'mdi-map-marker-radius-outline',
            href: 'https://apps.gis.msu.edu/facilities-information-tool/maps/benchmarks'
          },
          {
            title: 'INFRASTRUCTURE MAP (external)',
            description: 'This application is focused on infrastructure outside the building such as underground utilities, plants (managed trees and shrubs), stormwater best management practices and more.',
            icon: 'mdi-map-marker-radius-outline',
            href: 'https://apps.gis.msu.edu/facilities-information-tool/maps/infrastructure'
          },
          {
            title: 'IPF INDOORS (external)',
            description: 'Heavily focused on navigating, with room level directions, to assets, work orders, spaces, and more. This application is integrated with AppTree to quickly locate your work and is primarily intended for IPF staff and IPF campus partners.',
            icon: 'mdi-navigation-variant',
            href: 'https://gis.msu.edu/portal/apps/indoors/index.html?appid=86ebb70206df4ddcaf6250f540fecb58'
          },
          {
            title: "MSU INDOORS (external)",
            icon: "mdi-navigation-variant",
            href: `https://gis.msu.edu/portal/apps/indoors?appid=7409d0452fed4aa689de59f0feee4946`,
            description: 'The MSU Indoors application allows does not require you to log in and has information primarily intended public users and is primarily focused on focused on navigating, with room level directions, to campus features such as personal health spaces, class locations, points of interest, and more.'
          }
        ]
      }
    ]
  }),

  computed: {
    showOldVersionNotice() {
      let todaysDate = new Date();
      let endDate = new Date("10/01/2023");
      return todaysDate <= endDate;
    },

    routes() {
      return this.$router.getRoutes().filter((route) => {
        return (
            !route.redirect &&
            route.name !== "home" &&
            !route.meta.displayInNavigation &&
            route.name !== "definitions"
        );
      });
    },

    primaryRoutes() {
      const routes = this.$router.options.routes.filter((route) => {
        let meta = Object.assign({displayInNavigation: true}, route.meta);
        return !route.redirect && meta.displayInNavigation === true;
      });

      let mappedRoutes = routes.map((route) => {
        let childRoutes = [];
        if (route.children && route.children.length > 0) {
          console.info(
              route.meta.title,
              route.meta.title !== "redirect" && !route.meta.displayInNavigation
          );
          childRoutes = route.children.filter((route) => {
            let meta = Object.assign({displayInNavigation: true}, route.meta);
            return !route.redirect && meta.displayInNavigation === true;
          });
        }

        return {
          title: route.meta.title || route.name,
          to: route.name ? {name: route.name} : route.path.indexOf('https') === -1 ? route.path : null,
          href: route.path.indexOf('https') === 0 ? route.path : null,
          childRoutes: childRoutes.map((route) => {
            return {
              title: route.meta && route.meta.title ? route.meta.title : route.path,
              to: route.name ? {name: route.name} : route.path.indexOf('https') === -1 ? route.path : null,
              href: route.path.indexOf('https') === 0 ? route.path : null,
              icon: route.meta.icon || null,
              description: route.meta.description || null
            };
          }),
          icon: route.meta.icon,
          description: route.meta.description || null
        };
      });

      //mappedRoutes.splice(4, 0, this.mapLinks[0])

      return mappedRoutes
    },

    drawerCloseIcon() {
      return this.$vuetify.breakpoint.mdAndDown
          ? "mdi-chevron-down"
          : "mdi-chevron-left";
    },
  },

  methods: {
    getChildRoutes(routes) {
      return routes.filter((route) => {
        return !route.redirect && !route.children;
      });
    },
    trackFaqLinkClick() {
      console.log("Tracking FAQ click..");
      this.$gtm.trackEvent({
        category: "Main menu",
        action: "click",
        label: "FAQ",
        value: "FAQ",
      });
    },
  },

  mounted() {
    //this.drawer = this.$vuetify.breakpoint.mdAndUp
  },
};
</script>

<style>
@import "https://js.arcgis.com/4.19/@arcgis/core/assets/esri/themes/light/main.css";

.fill-width {
  width: 100% !important;
  max-width: 100%;
}
</style>

<style scoped>
.v-list-group__header.v-list-item.v-list-item--link.theme--light {
  padding-left: 8px !important;
}

.v-application--is-ltr
.v-list--dense.v-list--nav
.v-list-group--no-action
> .v-list-group__items
> .v-list-item {
  padding-left: 8px;
}

.v-list-group-header {
  padding-left: 0px !important;
}

.v-application--is-ltr
.v-list--dense.v-list--nav
.v-list-group--no-action.v-list-group--sub-group
> .v-list-group__items
> .v-list-item {
  padding-left: 12px;
}

.v-list--dense .v-list-item .v-list-item__icon,
.v-list-item--dense .v-list-item__icon {
  height: 16px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 8px !important;
  margin-left: 4px !important;
}

.v-subheader.v-list-group-header.theme--light {
  width: 100%;
}

.app-menu-group__header.v-list-group--active {
  border: solid;
  border-left-width: thin;
  border-right-width: thin;
  border-top-width: thin;
  border-bottom-width: thin;
  border-color: rgba(0, 0, 0, 0.12);
}

.app-menu-group__items {
  border: solid !important;
  border-left-width: 0px !important;
  border-right-width: 0px !important;
  border-top-width: thin !important;
  border-bottom-width: 0px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  background-color: #fff;
}

.v-list-item__content {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

a.pb-0.pt-0.v-list-item.v-list-item--link.theme--light {
  padding-left: 8px !important;
}

a.pb-0.pt-0.pl-0.v-list-item--primary-route.v-list-item.v-list-item--link.theme--light {
  padding-left: 8px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}


</style>

<style>
.v-toolbar__content {
  width: 100%;
}
</style>
